var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock308589(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 0.61341,
    x2: 0.61341,
    y1: 0.72846,
    y2: -0.53154,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.61338,
    x2: 0.61338,
    y1: 0.72392,
    y2: -0.55708,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0.3686,
    x2: 0.37809,
    y1: 0.3319,
    y2: 0.38362,
    xlinkHref: "#ab",
    spreadMethod: "reflect"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.48366,
    x2: 0.48366,
    y1: 0.1716,
    y2: 0.12313,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 0.44336,
    x2: 0.44336,
    y1: 1.0268,
    y2: -0.46437,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 0.41722,
    x2: 0.41722,
    y1: 0.012934,
    y2: 0.25036,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 0.47744,
    x2: 0.50908,
    y1: 0.23275,
    y2: 0.11468,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 0.18729,
    x2: 0.18022,
    y1: 0.78449,
    y2: 0.84915,
    xlinkHref: "#ab",
    spreadMethod: "reflect"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0.49146,
    x2: 0.89527,
    y1: 0.60604,
    y2: 0.60604,
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a47c44",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#baa363",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6c795",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe19c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b79e4f",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.50176,
    x2: 0.50176,
    y1: 0.39656,
    y2: 0.42242,
    xlinkHref: "#ab",
    spreadMethod: "reflect"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aw",
    cx: 8.0178,
    cy: 231.98,
    r: 7.4833,
    gradientTransform: "matrix(7.5313 0 0 .53795 3.9743 -.012826)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.6214 0 0 1.8821 -16.512 -15.97)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 8.0178,
    cy: 231.98,
    r: 7.4833,
    gradientTransform: "matrix(7.5313 0 0 .53795 3.9743 -2.0257)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "an",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.50007 0 0 1.6752 23.904 -11.668)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ay",
    cx: 8.0178,
    cy: 231.98,
    r: 7.4833,
    gradientTransform: "matrix(7.5313 0 0 .67244 3.9743 -34.231)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#ac"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "av",
    cx: 21.595,
    cy: 8.9814,
    r: 6.0679,
    gradientTransform: "matrix(-2.8463 0 0 2.0879 139.53 -3.5862)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "as",
    cx: 21.595,
    cy: 8.9814,
    r: 6.0679,
    gradientTransform: "matrix(2.3666 0 0 1.7265 -.40436 -.012826)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "at",
    cx: 21.595,
    cy: 8.9814,
    r: 6.0679,
    gradientTransform: "matrix(-2.3666 0 0 1.7265 129.12 -.11292)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 21.595,
    cy: 8.9814,
    r: 6.0679,
    gradientTransform: "matrix(3.085 0 0 2.0529 -15.985 -3.1493)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aq",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.50007 0 0 1.6752 -13.898 -11.668)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "am",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.43334 0 0 1.435 25.311 -6.6735)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ao",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.6214 0 0 1.8821 21.29 -15.97)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ap",
    cx: 20.361,
    cy: 22.546,
    r: 15.157,
    gradientTransform: "matrix(.43334 0 0 1.435 -12.491 -6.6735)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.359 2c-20.072 0-36.231 16.159-36.231 36.231v40.256h10.064v-40.256c0-14.496 11.67-26.167 26.167-26.167 14.496 0 26.167 11.67 26.167 26.167v40.256h10.064v-40.256c0-20.072-16.159-36.231-36.231-36.231z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.359 4.6292c-18.957 0-34.218 16.307-34.218 34.909v37.528c0 14.089 8.7764 26.05 21.26 31.047-8.9449-4.0729-15.222-12.8-15.222-23.147v-47.404c0-14.225 11.67-26.621 26.167-26.621h4.0256c14.496 0 26.167 12.396 26.167 26.621v47.404c0 10.347-6.2771 19.074-15.222 23.147 12.484-4.9976 21.26-16.958 21.26-31.047v-37.528c0-18.602-15.261-34.909-34.218-34.909z",
    fill: "url(#ak)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.359 2.8539c-19.51 0-35.217 15.601-35.217 34.98v39.095c0 14.677 9.0325 27.137 21.881 32.344-9.206-4.2429-15.666-13.334-15.666-24.113v-49.383c0-14.819 12.011-29.082 26.93-29.082h4.1431c14.919 0 26.93 14.263 26.93 29.082v49.383c0 10.779-6.4603 19.87-15.666 24.113 12.848-5.2063 21.881-17.666 21.881-32.344v-39.095c0-19.379-15.707-34.98-35.217-34.98z",
    fill: "url(#ai)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.471 12.003c-5.4384 3.4052-8.4987 9.2101-7.8995 11.145 0.64564 2.085 4.4667-7.2336 15.283-10.119 8.3406-2.2253-5e-4 -5.6487-7.3837-1.0257z",
    fill: "url(#as)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.248 11.903c5.4384 3.4052 8.4987 9.2101 7.8995 11.145-0.64565 2.085-4.4667-7.2336-15.283-10.119-8.3406-2.2253 4.88e-4 -5.6487 7.3837-1.0257z",
    fill: "url(#at)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.359 6.2794c-18.957 0-34.218 12.995-34.218 31.952v38.244c0 14.358 8.7764 26.546 21.26 31.639-8.9449-4.1505-15.222-13.044-15.222-23.588v-48.308c0-14.496 11.67-26.182 26.167-26.182h4.0256c14.496 0 26.167 11.686 26.167 26.182v48.308c0 10.544-6.2771 19.437-15.222 23.588 12.484-5.0929 21.26-17.281 21.26-31.639v-38.244c0-18.957-15.261-31.952-34.218-31.952z",
    fill: "url(#ah)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.359 4.0389c-26.762 0-32.938 23.315-32.938 33.86 0 31.634 2.0586 31.634 2.0586 0 0-23.199 16.463-32.355 30.879-32.355s30.879 10.103 30.879 32.355c0 31.634 2.0586 31.634 2.0586 0 0-10.545-6.1758-33.86-32.938-33.86z",
    fill: "url(#ag)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.359 7.0913c-26.167 0-32.205 22.3-32.205 31.987 0 29.062 2.0128 29.062 2.0128 0 0-21.312 16.097-30.605 30.192-30.605 14.096 0 30.192 10.162 30.192 30.605 0 29.062 2.0128 29.062 2.0128 0 0-9.6873-6.0385-31.987-32.205-31.987z",
    fill: "url(#af)",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.98 16.488c-2.8752 5.2482 3.0271 1.9311 4.398 0.27382 3.8539-4.659 10.368-8.0363 16.085-9.1385 4.7947-0.92436 5.5258-2.7757 1.5775-3.0822-7.8721-0.61105-19.304 6.9156-22.061 11.947z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.623 25.156c0.30478 2.5648 5.2635-5.7978 9.1677-9.7237 4.7683-4.7948 11.996-8.1508 15.474-8.5942 6.1984-0.79048 3.2564-3.828-0.62867-3.0606-14.12 2.7892-24.79 14.838-24.012 21.378z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.58 16.452c2.8946 5.2376-3.0199 1.9423-4.3969 0.29-3.871-4.6448-10.397-7.9981-16.119-9.0792-4.7981-0.9067-6.1484-2.7521-2.2014-3.0732 7.8698-0.64002 19.942 6.8412 22.717 11.862z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.798 24.925c-0.29533 2.5659-5.2848-5.7784-9.2035-9.6899-4.786-4.7772-12.026-8.1066-15.505-8.5372-6.2013-0.76765-3.2924-3.6952 0.61676-3.0622 14.142 2.3014 24.845 14.746 24.092 21.289z",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.032 11.138c-7.0895 4.049-11.079 10.951-10.298 13.252 0.84166 2.4791 5.8227-8.601 19.923-12.032 10.873-2.6459-6.52e-4 -6.7166-9.6253-1.2196z",
    fill: "url(#au)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.54 10.945c6.5408 4.1181 10.222 11.138 9.5008 13.478-0.77652 2.5214-5.3721-8.7479-18.381-12.238-10.031-2.6911 5.87e-4 -6.8312 8.8804-1.2405z",
    fill: "url(#av)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.72 124.78a56.359 4.0256 0 1 1 -112.72 0 56.359 4.0256 0 1 1 112.72 0z",
    fill: "url(#aw)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.72 121.76a56.359 5.0321 0 1 1 -112.72 0 56.359 5.0321 0 1 1 112.72 0z",
    fill: "url(#ay)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.72 122.77a56.359 4.0256 0 1 1 -112.72 0 56.359 4.0256 0 1 1 112.72 0z",
    fill: "url(#ax)",
    opacity: 0.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.103,
    y: 57.359,
    width: 80.513,
    height: 66.259,
    rx: 0.5,
    ry: 0.5,
    fill: "url(#az)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.103,
    y: 57.359,
    width: 80.513,
    height: 66.259,
    rx: 0.5,
    ry: 0.5,
    fill: "url(#ad)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.103,
    y: 57.359,
    width: 80.513,
    height: 66.259,
    rx: 0.5,
    ry: 0.5,
    fill: "url(#ae)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.103,
    y: 57.359,
    width: 80.513,
    height: 66.259,
    rx: 0.5,
    ry: 0.5,
    fill: "url(#al)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.619 57.359c1.8101 2.1216 18.145 3.7862 38.655 3.7862 20.229 0 36.293-1.6472 38.484-3.7271-0.03083-0.00322-0.025513-0.059158-0.05719-0.059158h-77.082z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7195 0 0 1.9816 4.4209 1.4876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.971 30.767c-0.43955 2.6295-0.93088 19.309 0.69644 22.88 1.5919 3.4933 1.3929-16.667 5.273-19.84 3.9212-3.2069-5.555-5.52-5.9695-3.04z",
    fill: "url(#ap)",
    opacity: 0.403
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.729 30.942c-0.50723 3.0697-1.0742 22.541 0.80369 26.71 1.837 4.0782 1.6074-19.457 6.0851-23.162 4.525-3.7437-6.4104-6.4441-6.8888-3.5489z",
    fill: "url(#aq)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.232 31.092c-0.6303 3.4488-1.3349 25.325 0.99868 30.009 2.2827 4.5818 1.9974-21.86 7.5614-26.022 5.6229-4.206-7.9657-7.2399-8.5601-3.9872z",
    fill: "url(#ar)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.7195 0 0 1.9816 124.3 1.4876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.971 30.767c-0.43955 2.6295-0.93088 19.309 0.69644 22.88 1.5919 3.4933 1.3929-16.667 5.273-19.84 3.9212-3.2069-5.555-5.52-5.9695-3.04z",
    fill: "url(#am)",
    opacity: 0.403
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.729 30.942c-0.50723 3.0697-1.0742 22.541 0.80369 26.71 1.837 4.0782 1.6074-19.457 6.0851-23.162 4.525-3.7437-6.4104-6.4441-6.8888-3.5489z",
    fill: "url(#an)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.232 31.092c-0.6303 3.4488-1.3349 25.325 0.99868 30.009 2.2827 4.5818 1.9974-21.86 7.5614-26.022 5.6229-4.206-7.9657-7.2399-8.5601-3.9872z",
    fill: "url(#ao)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.12 114.72v7.8872c0 0.55756-0.43214 1.0064-0.96891 1.0064h-75.575c-0.53678 0-0.96891-0.44886-0.96891-1.0064v-28.015c0 29.516 77.513-20.879 77.513 20.128z",
    fill: "url(#aj)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.646 123.62c1.8101-2.1216 18.145-3.7862 38.655-3.7862 20.229 0 36.293 1.6472 38.484 3.7271-0.03083 0.00322-0.025497 0.059158-0.057175 0.059158h-77.082z",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock308589);
export default __webpack_public_path__ + "static/media/padlock-308589.2e89456744107b4e6c1581cccf76f406.svg";
export { ForwardRef as ReactComponent };